import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { Tab, Title } from "@bookingcom/bui-react";
import { t } from "@bookingcom/lingojs-core";
import { useI18n } from "@bookingcom/lingojs-react";
import { getFlightsInterlinking } from "../../../store/flightsInterlinking/selector.js";
import { useTrackLandingPageViewport } from "../../../hooks/c360/useLandingPageEvents.js";
import Container from "../Container/index.js";
import styles from "./FlightsInterlinkingDesktop.module.css";
import { useFlightsInterlinkingPanelList } from "./useFlightsInterlinkingPanelList.js";
const FlightsInterlinkingDesktop = () => {
    const flightsInterlinking = useSelector(getFlightsInterlinking);
    const { panelsList, triggerList } = useFlightsInterlinkingPanelList(flightsInterlinking);
    const i18n = useI18n();
    const scrollRef = useRef(null);
    useTrackLandingPageViewport(scrollRef, "flights_interlinking");
    if (!flightsInterlinking || !panelsList.length || !triggerList.length) {
        return null;
    }
    const departureCountry = flightsInterlinking.departureCountry?.translatedName || "";
    return (React.createElement(Container, { className: styles.container, innerRef: scrollRef },
        React.createElement(Title, { className: styles.title, title: i18n.trans(t("flights_interlinking_index_header", { variables: { country_name: departureCountry } })), subtitle: i18n.trans(t("flights_interlinking_index_subheader", { variables: { country_name: departureCountry } })), variant: "headline_2", titleTagName: "h2" }),
        React.createElement(Tab, { variant: "rounded", defaultActiveTabId: triggerList[0]?.id },
            React.createElement(Tab.TriggerList, null, triggerList
                .filter((item) => {
                const value = flightsInterlinking?.[item.id];
                return Array.isArray(value) && value.length > 0;
            })
                .map((trigger) => (React.createElement(Tab.Trigger, { key: trigger.id, ...trigger })))),
            panelsList.map((panel) => (React.createElement(Tab.Panel, { key: panel.id, id: panel.id, keepMounted: true }, panel.children))))));
};
export default FlightsInterlinkingDesktop;
